import { render, staticRenderFns } from "./Ellipsifier.vue?vue&type=template&id=519b0e64&scoped=true&"
import script from "./Ellipsifier.vue?vue&type=script&lang=ts&"
export * from "./Ellipsifier.vue?vue&type=script&lang=ts&"
import style0 from "./Ellipsifier.vue?vue&type=style&index=0&id=519b0e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b0e64",
  null
  
)

export default component.exports